/* eslint-disable no-console */
import Button from "@app/components/move2Library/Button/Button"
import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import Page from "@app/components/pageTypes/Page/Page"
import { setLanguage } from "@app/store/actions/coreActions"
import { cmsApiSlice, locationCmsApiSlice, useGetStrings } from "@app/store/service/cmsService"
import { connectorApiSlice } from "@app/store/service/connectorService"
import { appStore } from "@app/store/store"
import { KioskBridge } from "@tecreation/bird5-kiosk-bridge"
import { Image } from "@tecreation/funnel-components"
import { useSelector } from "@tecreation/js-state-react"
import { useCallback, useEffect } from "react"
import Skeleton from "react-loading-skeleton"

export default function KioskEntrancePage() {
	const location = useSelector(state => state.core.location) || {}
	const { push } = useCustomNavigation()
	const {
		data: { buttonBookTicket },
	} = useGetStrings(undefined, { defaultData: {} })

	const applyLanguage = useCallback(language => {
		setLanguage(language)
		cmsApiSlice.utils.refresh()
		locationCmsApiSlice.utils.refresh()
		connectorApiSlice.utils.refresh()
	}, [])

	useEffect(() => {
		if (appStore.get("core.kioskMode")) {
			KioskBridge.execute("receipt.kiosk.stop").catch(e => {
				console.error(e)
			})
		}
		applyLanguage("de")
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<Page>
			<div className="flex">
				<div className="ml-auto flex p-3" style={{ height: "60px", gap: "8px" }}>
					{appStore.get("settings.languages").indexOf("de") !== -1 && (
						<div style={{ height: "100%", width: "60px" }} onClick={() => applyLanguage("de")}>
							<Image asBackground src="./img/de.png" style={{ height: "100%", width: "60px", backgroundPosition: "center", backgroundRepeat: "no-repeat" }} />
						</div>
					)}

					{appStore.get("settings.languages").indexOf("en") !== -1 && (
						<div style={{ height: "100%", width: "60px" }} onClick={() => applyLanguage("en")}>
							<Image asBackground src="./img/en.png" style={{ height: "100%", width: "60px", backgroundPosition: "center", backgroundRepeat: "no-repeat" }} />
						</div>
					)}

					{appStore.get("settings.languages").indexOf("fr") !== -1 && (
						<div style={{ height: "100%", width: "60px" }} onClick={() => applyLanguage("fr")}>
							<Image asBackground src="./img/fr.png" style={{ height: "100%", width: "60px", backgroundPosition: "center", backgroundRepeat: "no-repeat" }} />
						</div>
					)}
				</div>
			</div>

			<div className="flex flex-center flex-column h-100 mt-6 px-4">
				<div className="text-center f1">{location.welcomeSubHeading || <Skeleton />}</div>
				<div className="text-center f1">{location.locationTitle || <Skeleton />}</div>

				<div className="flex-1 w-100 mt-4 mb-3">
					{location ? (
						location.kioskEntranceImage && (
							<Image
								asBackground
								src={location.kioskEntranceImage.id}
								style={{ height: "100%", width: "100%", backgroundPosition: "center", backgroundRepeat: "no-repeat" }}
							/>
						)
					) : (
						<Skeleton />
					)}
				</div>

				<Button
					className="mt-3 mb-6"
					style="secondary"
					fillWidth
					onClick={() => {
						push("/")
					}}
				>
					{buttonBookTicket}
				</Button>
			</div>
		</Page>
	)
}
